<div id="promo-adjustment-hot-table" class="hot-table sku-config-table profit-table">
    <hot-table [hotId]="hotTableId" [settings]="hotTableSettings" [licenseKey]="handsontableLicenseKey"></hot-table>
</div>